import { h } from 'preact';
import * as BaseComp from 'components/bolt/footer/footer.js';
import { accessNested, joinClasses } from 'utils/utils';
import { getCopy } from 'utils/copy';
import { smoothScrollTo } from 'utils/smoothScroll';
import { getIsSinglePageIframed, hideFooter } from 'utils/bolt/client';
import Button from 'components/bolt/button/button';
import ArrowDown from 'components/bolt/icons/arrowDown';
import Store from 'store/store';

import s from 'components/bolt/footer/footer.sss';
export default class Footer extends BaseComp.default {
	render(props, state) {
		const activePage = Store.get()?.activePage;

		const newProps = {
			...props,
			data: {
				...props.data,
				defaultFooter: {
					...props.data?.defaultFooter,
					inline: activePage === 'map' ? false : accessNested(props.data, 'defaultFooter.inline', false)
				}
			}
		};

		return super.render(newProps, state);
	}

	renderOuter() {
		const accessibilityCopy = accessNested(this.props.store, 'appData.copy.accessibilityCopy', {});

		const { ctaOpenCopy = 'FOOTER_CTA', ctaCloseCopy = 'FOOTER_CLOSE' } = this.props.data.defaultFooter || {};
		const toggleButtonText = this.state.open ? getCopy(ctaCloseCopy, {}, '', null, 'baseCopy') : getCopy(ctaOpenCopy, {}, '', null, 'baseCopy');
		const toggleButtonAria = this.state.open ? accessibilityCopy.$COLLAPSE_FOOTER_ARIA : accessibilityCopy.$EXPAND_FOOTER_ARIA;
		const copyright = accessNested(this.props.data, 'defaultFooter.copyright');
		const isSinglePageIframed = getIsSinglePageIframed();
		const store = Store.get();
		const isMobileLandscape = accessNested(store, 'client.deviceSize') === 'mobile' && accessNested(store, 'client.orientation') === 'landscape';
		const isTablet = accessNested(store, 'client.deviceSize') === 'tablet';

		return (
            
			<div class={joinClasses(s.outer, (isMobileLandscape || isTablet) && s.mobileLandscape, isSinglePageIframed && s.noLegalBtn)} key="outer">
				<Button
					class={joinClasses(s.cta, this.fontStyles.footerLegalButton, isSinglePageIframed && s.hidden)}
					trigger={this.toggleFooter}
					key="toggle"
					ariaLabel={toggleButtonAria}
					ref={e => this.$cta = e}
				>
					{toggleButtonText}
				</Button>
			</div>
		);
	}
}